module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-travel-default/individual-travel-default.component.css
// module id = ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-travel-default/individual-travel-default.component.css
// module chunks = main